module.exports = __webpack_public_path__ + "static/Trafiurbe-bd87fc6a46dbf8e8d892db0399d6ff2a.webp";